import { handleResponse } from '@shared/api/handle-response';
import { httpClient } from '@shared/api/http-client';
import type { HandleResponse } from '@shared/api/types';

import { AUTH_REFRESH_ENDPOINT } from './endpoints';

/**
 * Обновляет cookie-сессию через BFF endpoint `/refresh`.
 */
export const refreshSession = async (): Promise<HandleResponse<void>> => {
	const response = await httpClient.post<void>(AUTH_REFRESH_ENDPOINT);

	return handleResponse(response);
};
